import React from "react";
import { ConvexProvider, ConvexReactClient } from "convex/react";

const convexUrl = process.env.REACT_APP_CONVEX_URL;
const convexClient = convexUrl ? new ConvexReactClient(convexUrl) : null;

export const MaybeConvexProvider = ({ children }) => {
  if (!convexClient) {
    return children;
  }

  return <ConvexProvider client={convexClient}>{children}</ConvexProvider>;
};
